module.exports = __webpack_public_path__ + "img/n6-bg2.b01b4e49.png";